/**
 * Service/ChangeAlias Controller
 *
 * 
 */

// the constructor for this object
function ServiceChangeAliasController() { }

// the object
ServiceChangeAliasController.prototype = {
    constructor: ServiceChangeAliasController,
    
    // the base order id
    baseOrderId: false,
    
    // the product code of the order
    productCd: false,
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        // register the route variables used by this controller
        this._registerRouteVariables();
        
        PortalHelper.debugMessage('Change Alias Controller Initialized');
    },
    
    // run the controller
    run: function()
    {
        // get information about the order
        this._getOrder();
        
        // register the events used by this controller
        this._registerEvents();
        
        PortalHelper.debugMessage('Change Alias Controller Ran');
    },
    
    // get the route variables and include them in the controller
    _registerRouteVariables: function() 
    {
        var segments = PortalMain.getRouteSegments();
        
        // set the base order id
        if (segments.length == 1) {
            this.baseOrderId = segments[0];
        } else {
            // the uri is missing important pieces
            PortalHelper.sendToDashboard();
        }
    },
    
    // register the javascript events
    _registerEvents:  function()
    {   
        var self = this;
        $('#change-alias-form').on('submit', function(e) {
            e.preventDefault();
            
            PortalMain.ServiceChangeAliasController._changeAlias();
        });
    },
    
    // set the breadcrumbs according to the current product, and order
    _setBreadcrumbs: function(data)
    {
        //get the product group
        var group = PortalMain.PortalProducts.getProductGroupByProductCd(data.product_cd);
        var url = '/portal/services/' + group.path;
        $('.breadcrumbs .bc-service-group').attr('href', url);
        $('.breadcrumbs .bc-service-group').html(group.label);
    
        // set the specific order number
        var orderLink = PortalMain.PortalProducts.getProductLink(data.product_cd, data.base_order_id);
        $('.breadcrumbs a:nth-child(4)').attr('href', orderLink);
        $('.breadcrumbs a:nth-child(4)').html('#' + data.order_number);
        
        $('.breadcrumbs').removeClass('hidden');
    },
    
    // get the order from the api
    _getOrder: function()
    {
        // make the request
        var orderRequest = new PortalRequest;
        orderRequest.makeRequest(
            '/orders/get-order',
            {
                baseOrderId: this.baseOrderId
            },
            function(data) {
                
                // set the breadcrumbs
                PortalMain.ServiceChangeAliasController._setBreadcrumbs(data);
                
                // set the alias
                var alias = PortalHelper.htmlspecialcharsDecode(data.alias);
                $('#alias').val(alias);
                
                // store the product cd
                PortalMain.ServiceChangeAliasController.productCd = data.product_cd;
                
                // enable the button
                PortalHelper.enableButton('#change-order-alias-button');
                
                // show the form
                $('#change-alias-form').removeClass('loading');
            }
        );
    },
    
    // make an api request to change an orders alias 
    _changeAlias: function()
    {
        $('.form').addClass('loading');
        var alias = $('#alias').val();
        
        var changeAliasRequest = new PortalRequest();
        changeAliasRequest.errorElement = '.form-errors';
        changeAliasRequest.makeRequest(
            '/orders/change-alias',
            {
                base_order_id: this.baseOrderId,
                alias: alias
            },
            function(response) {
                $('.form').removeClass('loading');
                $('.form .form-success').removeClass('hidden');
                PortalHelper.disableButton('#change-order-alias-button');
                
                // go back to the previous page
                setTimeout(function () {
                    var returnLink = PortalMain.PortalProducts.getProductLink(
                        PortalMain.ServiceChangeAliasController.productCd, 
                        PortalMain.ServiceChangeAliasController.baseOrderId
                    );
                    window.location = returnLink;
                }, 3000);
            },
            function(response) {
                $('.form').removeClass('loading');
            }
        )
    },
    
}